export default {
    methods: {
        fillByPageLoadParameters(fromAcf = false) {
            if (window.location.hash) {
                // Get URL parameters
                // console.log('fillByPageLoadParameters executed');
                let onLoadParameters = decodeURIComponent(window.location.hash.replace('#!/', ''));

                // Create object from parameters
                let parametersObject = JSON.parse('{"' + decodeURI(onLoadParameters).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

                console.log(parametersObject);
                this.setFilterValues(parametersObject);
            } else if (fromAcf == true) {
                let parametersObject = {};
                console.log('filters joe', this.settedFiltersFromACF);
                if (this.settedFiltersFromACF) {
                    for (let row of this.settedFiltersFromACF) {

                        let rowName = row.filter_name;
                        let rowValue = row.filter_value;
                        parametersObject[rowName] = rowValue;
                    }
                }

                console.log(parametersObject);
                this.setFilterValues(parametersObject);
            }
        },
        setFilterValues(parObject) {
            // Loop throug object and set Vue data values
            let _this = this;

            if (typeof parObject === 'object' && parObject !== null) {
                for (const [key, value] of Object.entries(parObject)) {
                    // Process as array with numbers
                    if (key == 'custom_search') {
                        _this.settedFilters.productTextSearch = value;
                    }

                    if (key == 'product_category' || key == 'secondary_play_value_ids' || key == 'thema_value') {
                        var finalValue = value.split`,`.map(x => +x);
                        _this.settedFilters.checkedTaxonomies[key] = finalValue;

                        // Open filterblock
                        _this.filterVisibility[key] = true;

                        // Check checkboxes
                        setCheckboxAttribute(finalValue);
                    }

                    // Process as array with strings
                    if (key == 'website_main_category') {
                        var finalValue = value.split(',');
                        _this.settedFilters.checkedTaxonomies[key] = finalValue;

                        // Open filterblock
                        _this.filterVisibility[key] = true;

                        // Check checkboxes
                        setCheckboxAttribute(finalValue);
                    }

                    // Process as number
                    if (key == 'primary_play_value_id') {
                        var finalValue = parseInt(value);
                        _this.settedFilters.checkedTaxonomies[key] = finalValue;
                        setSelectOption(key, value);
                    }

                    // Set ranges and update range slider
                    if (key == 'falling_height' || key == 'list_price') {

                        let rangeItems = _this.settedFilters.ranges;
                        for (var forKey = 0; forKey < rangeItems.length; forKey++) {

                            // _this.settedFilters.ranges.forEach(function (rangeItem) {
                            if (rangeItems[forKey].name == key) {
                                var finalValue = value.split(',');
                                rangeItems[forKey].min_value = finalValue[0];
                                rangeItems[forKey].max_value = finalValue[1];

                                // Connect to correct slider id
                                if (key == 'falling_height') {
                                    var sliderInstance = document.getElementById('vue__range-slider-0');
                                } else if (key == 'list_price') {
                                    var sliderInstance = document.getElementById('vue__range-slider-1');
                                }

                                let updatedMin = parseInt(rangeItems[forKey].min_value);
                                let updatedMax = parseInt(rangeItems[forKey].max_value);

                                sliderInstance.noUiSlider.updateOptions({
                                    start: [updatedMin, updatedMax]
                                });

                            }
                        }
                    }

                    // setCheckboxAttribute() and setSelectOption() are only used on Catalog page. On Projects everything is binded correctly so it's not necessary to manually set/check/select the html elements.
                    function setCheckboxAttribute(values) {
                        for (var i = 0; i < values.length; i++) {
                            let item = document.getElementById(values[i]);
                            item.checked = true;
                        }

                    }

                    function setSelectOption(key, value) {
                        document.getElementById(key).value = value;
                    }

                    // Project filters
                    // As mentioned above no need to manually set/check/select html elements, vue binding does that for us.
                    let filtersObject = this.filters.allExternalProjectFilters;
                    for (var fKey in filtersObject) {
                        let type = filtersObject[fKey]['type'];
                        let slug = filtersObject[fKey]['slug'];
                        let paramSlug = key;

                        if (slug == paramSlug) {
                            // check every type so value will be filled correctly
                            if (type == 'text') {
                                filtersObject[fKey]['value'] = value;
                            } else if (type == 'radio') {
                                filtersObject[fKey]['checked'] = value;
                            } else if (type == 'dropdown') {
                                filtersObject[fKey]['selected'] = value;
                            } else if (type == 'checkbox') {

                                //Convert string with multiple values to array
                                let valArray = value.split(',');

                                //Loop throug all checkboxes and set checked if value exists in valArray
                                let filterItems = filtersObject[fKey].items;
                                for (var iKey in filterItems) {
                                    if (valArray.includes(filterItems[iKey]['value'])) {
                                        filterItems[iKey]['checked'] = true;
                                    }
                                }
                            }

                            // Set block open if value is not empty
                            if (value) {
                                filtersObject[fKey]['open'] = true;
                            }
                        }
                    }
                }
            } else {
                console.warn('URL parameters are not an object');
            }
        }
    }
}
